// extracted by mini-css-extract-plugin
module.exports = {"searchHorizontalRecosContainer":"tT","reco":"uT","products":"vT"};